module.exports = "//public.getcloudapp.com/packs/media/images/indicator-right-3a34696d799da7554a51e8e6104d590e.svg";